import PanelSeparator from "@/components/pages/Community/PanelSeparator/PanelSeparator";

export default PanelSeparator;
